module.exports = __webpack_public_path__ + "static/3-5-239ddd544df5936666bedc0f591b0f9f.jpg";